module.exports = __webpack_public_path__ + "img/扶梯7.74a24a4b.png";